// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"442":"77ffffcf","754":"2e88e555","845":"999370a7","933":"50e82117"}[chunkId] + ".chunk.js";
};